import type { ApolloError, DocumentNode } from '@apollo/client';

export function getGqlString(doc: DocumentNode) {
  return doc.loc && doc.loc.source.body;
}

export function isApolloErrorAbort(error: any) {
  return (error as ApolloError)?.message?.includes('The user aborted a request.');
}
